import { render, staticRenderFns } from "./zombies.vue?vue&type=template&id=2cf5e21c&scoped=true"
import script from "./zombies.vue?vue&type=script&lang=js"
export * from "./zombies.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cf5e21c",
  null
  
)

export default component.exports